/**
 * Which seat on a team a person holds: the leader's, or a member's.
 *
 * The values are the names `Work.WorkRecords.WorkTeamRole` binds from a list URL, where it says
 * which seat `teamMemberUserId` holds.
 */
export enum WorkTeamRole {
  Leader = "Leader",
  Member = "Member",
}
